<template>
	<div class="sf-datatable-wrapper">
		<div class="sf-datatable-container">
			<div class="sf-card__header mt-3">
				<div class="d-flex align-items-end">
					<!--R/O정보-->
					<span class="title"><i class="sf-icon icon-sf-caret-right" />{{ getMessage_('QWCC001175') }}</span>
				</div>
			</div>

			<div class="sf-table">
				<table class="qms-table">
					<tbody>
						<tr>
							<th class="col-1">Ro No.</th>
							<td class="col-1"><el-input v-model="roNo" readOnly /></td>
							<!--처리단계-->
							<th class="col-1">{{ getMessage_('QWCC000963') }}</th>
							<td class="col-1">
								<el-input v-model="prcsStepNmr" readOnly />
							</td>
							<!--신청일-->
							<th class="col-1">{{ getMessage_('QWCC000979') }}</th>

							<td class="col-1">
								<el-input v-model="aplcDdr" readOnly />
							</td>
							<!--확정일-->
							<th class="col-1">{{ getMessage_('QWCC000980') }}</th>
							<td class="col-1">
								<el-input v-model="dcsnDdr" readOnly />
							</td>

							<!--R/O 신청자-->
							<th class="col-1">{{ getMessage_('QWCC002090') }}</th>
							<td class="col-1">
								<el-input v-model="aplcNmr" readOnly />
							</td>
						</tr>
					</tbody>
				</table>
			</div>
		</div>
	</div>
</template>

<script>
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '../../../store/helpers';
import { convertNvl } from '@/qmsUtils/'; //공통함수 import
import moment from 'moment';
export default {
	props: {
		scrId: { type: String, default: '' }
	},
	components: {},
	data() {
		return {
			roNo: '', //roNo
			prcsStepr: '',
			prcsStepNmr: '',
			aplcDdr: '',
			dcsnDdr: ''
		};
	},
	computed: {
		...rootComputed,
		...serviceComputed,
		chgFlag() {
			return this.getIsSaveFlag_;
		}
	},
	methods: {
		...rootMethods,
		...serviceMethods,
		setProcessInfo() {
			this.roNo = this.roApcnPopUp.roNo; // PWANO
			this.prcsStepr = this.roApcnPopUp.prcsStepr; //RO처리단계코드
			this.prcsStepNmr = this.roApcnPopUp.prcsStepNmr; // 처리단계명
			this.aplcDdr = this.roApcnPopUp.aplcDdr; //신청일
			this.dcsnDdr = this.roApcnPopUp.dcsnDdr; //확정일
			this.aplcNmr = this.roApcnPopUp.aplcNmr; //R/O신청자
		}
	},
	async created() {
		//스토어에서 값을 가져와서 셋팅한다.

		this.roNo = this.roApcnPopUp.roNo; // PWANO
		this.prcStepr = this.roApcnPopUp.prcStepr; //처리단계코드
		this.prcsStepNmr = this.roApcnPopUp.prcsStepNmr; // 처리단계명
		this.aplcDdr = this.roApcnPopUp.aplcDdr; //신청일
		this.dcsnDdr = this.roApcnPopUp.dcsnDdr; //확정일
		this.aplcNmr = this.roApcnPopUp.aplcNmr; //R/O신청자
	},
	watch: {
		chgFlag() {
			// true 일때 해당 data를 store에 담는 작업 시작
			if (this.getIsSaveFlag_) {
				this.setStateApcnSave_({ key: 'roNo', value: convertNvl(this.roNo, '') }); // RO번호
				this.setStateApcnSave_({ key: 'prcStepr', value: convertNvl(this.prcStepr, '') }); //처리단계코드
				this.setStateApcnSave_({ key: 'prcsStepNmr', value: convertNvl(this.prcsStepNmr, '') }); // 처리단계명
				this.setStateApcnSave_({ key: 'aplcNmr', value: convertNvl(this.aplcNmr, '') }); // R/O신청자
				//this.setStateApcnSave_({ key: 'aplcDd', value: moment(convertNvl(this.aplcDd, '')).format('YYYYMMDD') }); //신청일
				//this.setStateApcnSave_({ key: 'dcsnDd', value: moment(convertNvl(this.dcsnDd, '')).format('YYYYMMDD') }); //확정일
			}
		}
	}
};
</script>
<style>
.sf-input-group-wrapper__label {
	color: aqua;
}
.search-option-wrapper__normal {
	position: relative;
}
.search-icon {
	color: var(--color-default);
	font-size: 1.5rem;
	position: absolute;
	right: 0;
	cursor: pointer;
	top: -3px;
}
</style>
